import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Meteor } from 'meteor/meteor';
import { strings } from '/imports/strings';
import { LoadingFullScreen } from '/imports/ui/LoadingFullScreen';

const LogoutStyled = styled.div`
`;

/** Logs the user out on mount and shows a full-screen loader. */
export const Logout = () => {
  useEffect(() => { Meteor.logout(); }, []);
  return (
    <LogoutStyled className="logout">
      <LoadingFullScreen caption={strings.Logout()} />
    </LogoutStyled>
  );
};